import styled, { css } from 'styled-components';
import { AngleLeft16, AngleRight16 } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';

export interface ArrowControlProps {
  direction: 'left' | 'right';
  size?: number;
  onClick(): void;
}

export const ArrowControl = ({
  size = 26,
  direction,
  onClick
}: ArrowControlProps) => {
  const IconComponent = direction === 'left' ? AngleLeft16 : AngleRight16;

  return (
    <ArrowControlContainer
      _direction={direction}
      _size={size}
      tabIndex={0}
      onClick={onClick}
    >
      <ArrowControlIcon size={16} component={IconComponent} />
    </ArrowControlContainer>
  );
};

const ArrowControlContainer = styled.button<{
  _direction: 'left' | 'right';
  _size: number;
}>`
  position: absolute;
  display: block;
  width: ${({ _size }) => `${_size}px`};
  height: ${({ _size }) => `${_size}px`};
  padding: 0;
  border: none;
  outline: none;
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  top: ${({ _size }) => `calc(50% - ${_size / 2}px)`};
  z-index: 1;

  ${({ _direction, _size }) =>
    _direction === 'left'
      ? css`
          left: -${_size}px;
        `
      : css`
          right: -${_size}px;
        `};
`;

const ArrowControlIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
`;
